import { CONFIG } from "../../actions/actionConstants.js";

export const INITIAL = {
  isError: false,
  isReady: false,
  isFetching: false,
  data: {}
};

export function configReducer(state = INITIAL, action = {}) {
  switch (action.type) {
    case CONFIG.GET:
      return state;

    case CONFIG.REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case CONFIG.RECEIVE:
      return {
        ...state,
        isFetching: false,
        isReady: true,
        data: action.payload
      };

    case CONFIG.FAILURE:
      return {
        ...state,
        isError: true,
        isFetching: false,
        isReady: false
      };

    default:
      return state;
  }
}
